export default "__VITE_ASSET__29bcad7c__"